import { createPortal } from 'react-dom';
import { DrawerBox, DrawerBody, DrawerContainer, DrawerHeader } from './style';
import { CloseIcon } from './icons';
import React, { useRef } from 'react';

interface DrawerProps extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  onClose: () => void;
  withContainer?: boolean;
}

export default function Drawer({
  open,
  onClose,
  withContainer = true,
  children,
  title,
  ...props
}: DrawerProps) {
  const ref = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   if (!open) return;

  //   ref.current.focus();
  // }, [open, ref.current]);

  // useOutsideClick(ref, () => {
  //   onClose();
  // });

  if (!open) return <></>;

  if (withContainer) {
    return createPortal(
      <DrawerContainer ref={ref}>
        <DrawerBox {...props}>
          <DrawerHeader>
            <span className="title">{title}</span>

            <button onClick={onClose}>
              <CloseIcon />
            </button>
          </DrawerHeader>

          <DrawerBody>{children}</DrawerBody>
        </DrawerBox>
      </DrawerContainer>,
      document.body
    );
  }

  return createPortal(
    //@ts-ignore
    <DrawerBox withContainer={withContainer} {...props}>
      <DrawerHeader>
        <span className="title">{title}</span>

        <button onClick={onClose}>
          <CloseIcon />
        </button>
      </DrawerHeader>

      <DrawerBody>{children}</DrawerBody>
    </DrawerBox>,
    document.body
  );
}
